import { logUsage } from 'owa-analytics';
import { AttachmentFileList } from 'owa-attachment-file-types';
import {
    lazyCreateCloudFileFromAttachmentData,
    ReplyWithAttachmentSuggestion,
} from 'owa-attachment-suggestions';
import { lazyInsertLinks } from 'owa-insert-link';
import { InsertLinksHost } from 'owa-attachment-link-common';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { checkUserSelectionText } from './checkUserSelectionText';

export async function onSuggestionAttachmentClicked(
    suggestion: ReplyWithAttachmentSuggestion,
    insertLinksHost: InsertLinksHost,
    editorViewState: EditorViewState,
    fromAddress: string,
    targetWindow: Window
): Promise<void> {
    logUsage('HyperlinkContextMenu', { source: 'SuggestionAttachment' });

    // Check user selection and decide whether to continue
    const { shouldContinue, selectionText } = await checkUserSelectionText(editorViewState);
    if (!shouldContinue) {
        return;
    }

    const insertLinks = await lazyInsertLinks.import();
    const createCloudFileFromAttachmentData = await lazyCreateCloudFileFromAttachmentData.import();
    await createCloudFileFromAttachmentData(suggestion, cloudFile => {
        const files: AttachmentFileList = [cloudFile];
        insertLinks(
            files,
            insertLinksHost,
            editorViewState,
            fromAddress,
            targetWindow,
            selectionText /* selectionText */
        );
    });
}
